import React from 'react';
import {SectionDetail, Tabs, Tab, TabPanel, Button, SmartTagText, Text} from 'components/core';
import {Grid, Accordion, AccordionSummary, AccordionDetails} from '@material-ui/core';
import {TasksCtx, TaskFilesCtx, TaskFilesProvider} from 'components/dataProviders/tasks';
import {ProceduresCtx} from 'components/dataProviders/procedures';
import {TaskReportsCtxProvider} from 'components/dataProviders/tasks.reports';
// import {TaskStepsCtxProvider} from 'components/dataProviders/taskSteps';
 import {Edit, ExpandMore} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import FilesList from 'components/files/FilesList';
import EditDialog from './dialog';
import Reports from './reports/report';
import clsx from 'clsx';
import { AssignmentLate } from '@material-ui/icons';

import {RaymanUser, UserSize} from 'components/core';

const styles = makeStyles((theme) => ({
  infoHeader: {
    fontSize: '13px',
    FontWeight: 400,
    color: theme.palette.text.primary,
    marginBottom: 3
  },
  infoRoot: {
    padding: 25
  },
  infoPair: {
    marginTop: 25
  },
  infoTitle: {
    fontSize: '18px',
    FontWeight: 800,
    color: theme.palette.text.secondary
  },
  infoField: {
    fontSize: '15px',
    FontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "pre-line"
  },
  items: {
    marginTop: 25,
    display: 'inline-flex',
    flexWrap: "wrap",
    '& > *': {
      margin: 5
    }
  },
  red: {
    color: theme.palette.error.main
  },
  centered: {
    width: "100%",
    height: "80%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  empty: {
      display: "flex",
      flexDirection: "column",
      '& $icon':
      {
          opacity: 0.2,
          width: 150,
          height: 150
      }
  },
  icon: {}
}), {name: "RaymanTasks"});

function DueDatesField({task})
  {
    const classes = styles();
    const overdue = task.status !== "completed" && task.maxStartDate && new Date(task.maxStartDate) <= new Date();
    
    const startText = task.minStartDate === null ? null : new Date(task.minStartDate).toLocaleString("es-ES", {
      weekday: "long", 
      day: "numeric", 
      month: "long", 
      year: new Date(task.minStartDate).getFullYear() !== new Date().getFullYear() ? "numeric" : undefined
    });
    const endText = task.maxStartDate === null ? null : new Date(task.maxStartDate).toLocaleString("es-ES", {
      weekday: "long", 
      day: "numeric", 
      month: "long", 
      year: new Date(task.minStartDate).getFullYear() !== new Date().getFullYear() ? "numeric" : undefined
    });
    
    return <Text className={overdue ? classes.red : ""}> {startText && endText ? (startText === endText ? `El ${startText}` : `Entre el ${startText} y el ${endText}`) : 
              startText ? `A partir del ${startText}` : `Antes del ${endText}`} </Text>
  }


export default function TasksPanel({taskID, onClose = () => {}, editable})
{
    const classes = styles();
    const [selectedTab, setSelectedTab] = React.useState(0);
    const tasksCtx = React.useContext(TasksCtx);
    const procsCtx = React.useContext(ProceduresCtx);
    const filesCtx = React.useContext(TaskFilesCtx);
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);
    const taskStates = {
      'completed': "Completada",
      'in_progress': "En curso",
      'not_started': "Pendiente"
    }
    const priorities = {
      'low': "Baja",
      'normal': "Normal",
      'important': "Importante",
      'urgent': "Urgente"
    }
    const handleClose = () => {
        onClose();
    }

    if(!taskID) return null;

    const detailTabs = <Tabs value={selectedTab} onChange={(evt, index) => setSelectedTab(index)} textColor="primary" indicatorColor="primary">
        <Tab label="Tarea"/>
        <Tab label="Informes"/>
    </Tabs>

    const task = tasksCtx.data.indexed[taskID];
    if(!task) return null;

    const header = <Grid container direction="row" spacing={2} justify="space-between">
      <Grid item><Grid container direction="row" spacing={1}>
        {editable && <Grid item><Button color="secondary" fullWidth={false} onClick={()=>setEditDialogOpen(true)}><Edit /> Editar</Button></Grid> }
        {!editable && <Grid item><Text title>{task.name}</Text></Grid> }
        {/* {!task.closed && <Grid item><Button color="error" fullWidth={false}><Archive /></Button></Grid> }
        {task.closed && <Grid item><Button color="secondary" fullWidth={false}><Unarchive /></Button></Grid> } */}
      </Grid></Grid>
    </Grid>
    
    return <SectionDetail onCloseClick={() => handleClose()} tabs={detailTabs} header={header} >
          <EditDialog open={editDialogOpen} handleClose={()=>setEditDialogOpen(false)} taskID={taskID} />
          <TabPanel value={selectedTab} index={0}>
            <div className={classes.infoRoot}>
              <div className={classes.infoPair}>
                <div className={classes.infoTitle}>{task.name}</div>
              </div>
              {task.schedulerID && <>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Periodicidad</div>
                <div className={classes.infoField}>[TO DO]</div>
                <div className={classes.infoField}>[Enlace al scheduler]</div>
              </div>
              </>}
              <div className={classes.infoPair}> 
                <div className={classes.infoHeader}>Estado</div>
                <div className={classes.infoField}>{taskStates[task.status]}</div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Asignada por</div>
                <div className={classes.infoField}><RaymanUser userID={task.lastModificationUser} size={UserSize.size24} /></div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>A realizar por</div>
                <div className={classes.infoField}>{ task.asignees.map( asignee => <RaymanUser key={asignee} userID={asignee} size={UserSize.size24}/> ) }</div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Fecha de ejecución</div>
                <div className={classes.infoField}><DueDatesField task={task} /></div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Prioridad</div>
                <div className={classes.infoField}>{priorities[task.priority]}</div>
              </div>
              
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Procedimiento</div>
                <div className={classes.infoField}>
                  {task.procedureDescription ? <>
                  <Accordion className={classes.stepAccordion} elevation={0}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <div className={classes.stepTitle}>{task.procedureName}</div>
                    </AccordionSummary>

                    <AccordionDetails className={classes.accordionContent}>
                      <div className={classes.infoField}>{task.procedureDescription}</div>  
                    </AccordionDetails>
                </Accordion>
                </> : <>
                    {task.procedureName ? task.procedureName : procsCtx.data.indexed[task.procedureID]?.name}
                </>}
                </div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Observaciones</div>
                <div className={classes.infoField}>{task.info}</div>
              </div>
              <div className={classes.infoPair}>
                <div className={classes.infoHeader}>Etiquetas</div>
                <div className={classes.infoField}><SmartTagText tagIDs={task.tags} /></div>
              </div>
              { filesCtx.data.array.length > 0 && 
                <div className={classes.infoBlock}>
                  <div className={classes.infoLabel}>Archivos</div>
                  <div className={classes.infoField}><FilesList context={TaskFilesCtx} /></div>
                </div>
              }
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            {task.status === "not_started" ? 
              <div className={clsx(classes.centered, classes.empty)}>
                <AssignmentLate className={classes.icon} /><br />
                <Text title>Todavía no hay informes</Text>
                <Text>Vuelve cuando se haya completado la tarea</Text>
              </div>
            : 
              <TaskReportsCtxProvider taskID={task.id}>
                <Reports taskID={task.id}/>
              </TaskReportsCtxProvider>
            }
          </TabPanel>
    </SectionDetail>
}
